import { removeAllMediaElementsFromPageAction as removeAllMediaElementsFromPageOperation } from 'editor/src/store/design/slice';

export default removeAllMediaElementsFromPageOperation;
